var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('header-component',{attrs:{"title":"404 Page"}}),_c('div',{staticClass:"my-5 text-center"},[_c('h1',{staticClass:"pt-5 mb-5 warning--text"},[_vm._v(" 404 Page Not Found ")]),_c('v-btn',{staticClass:"mt-5",attrs:{"color":"primary"},on:{"click":_vm.goBack}},[_vm._v(" Go Back ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }